
import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'How much does your service cost?',
      answer: 'Our service is completely free for accident victims. We are compensated by our network of attorneys and medical providers, so there is no cost to you whatsoever.'
    },
    {
      question: 'How quickly will I be connected with an attorney?',
      answer: 'We typically connect you with a qualified attorney within 24 hours of submitting your case information. In urgent cases, we can often arrange same-day consultations.'
    },
    {
      question: 'What types of cases do you handle?',
      answer: 'We handle auto accidents, work injuries, medical malpractice, slip and fall cases, and other personal injury claims in the Las Cruces and Southern New Mexico area.'
    },
    {
      question: 'Do I have to use the attorney you recommend?',
      answer: 'No, you are under no obligation to use any attorney we recommend. We simply connect you with qualified professionals, and the final decision is always yours.'
    },
    {
      question: 'How long do I have to file a claim in New Mexico?',
      answer: 'In New Mexico, the statute of limitations for most personal injury cases is three years from the date of the accident. However, it\'s best to act quickly to preserve evidence and strengthen your case.'
    },
    {
      question: 'What if I was partially at fault for the accident?',
      answer: 'New Mexico follows a comparative negligence rule, which means you can still recover damages even if you were partially at fault. Your compensation will be reduced by your percentage of fault.'
    }
  ];

  return (
    <section className="py-16 md:py-20 bg-gradient-to-b from-[#FFF8F0] to-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-700">
            Get answers to common questions about our services
          </p>
        </div>

        <div className="space-y-3 md:space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl shadow-lg overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-4 py-4 sm:px-6 sm:py-5 flex justify-between items-center text-left hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <h4 className="text-sm sm:text-base md:text-lg font-bold text-gray-900 pr-4">
                  {faq.question}
                </h4>
                <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-xl md:text-2xl text-[#D2691E] flex-shrink-0`}></i>
              </button>
              {openIndex === index && (
                <div className="px-4 pb-4 sm:px-6 sm:pb-5 pt-0">
                  <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
